module.exports = __webpack_public_path__ + "cbd7e3c33d280bbf62d4d679b201f074.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-beach.png
// module id = 2770
// module chunks = 0